import {Client} from "@/endpoints/rutsolve/gql/resolvers/client"
import {
    Deliverable as DeliverableModel,
    CreateDeliverableDocument,
    UpdateDeliverableDocument,
    DeliverableInput,
    CreateDeliverableMutationVariables,
    DeliverableSelectorQueryVariables,
    UpdateDeliverableMutationVariables,
    DeliverableSelectorDocument,
    DeliverableResponse,
    DeliverableSummaryQueryVariables,
    DeliverableSummaryDocument,
    RemoveDeliverableMutationVariables,
    RemoveDeliverableDocument
} from "@/endpoints/rutsolve/gql/generated/graphql"

export class Deliverable extends Client {
    constructor() {
        super()
    }

    public async summary(deliverableID: string): Promise<DeliverableModel> {
        try {
            const variables: DeliverableSummaryQueryVariables = {
                deliverableID: deliverableID
            }
            const response = await this.client.request(DeliverableSummaryDocument, variables)
            return response.deliverable
        } catch (error) {
            this.handleError(error)
        }
    }

    public async selector(input?: DeliverableInput): Promise<DeliverableResponse> {
        try {
            const variables: DeliverableSelectorQueryVariables = {
                input: input
            }
            const response = await this.client.request(DeliverableSelectorDocument, variables)
            return response.deliverables
        } catch (error) {
            this.handleError(error)
        }
    }

    public async create(input: DeliverableModel): Promise<string> {
        try {
            const variables: CreateDeliverableMutationVariables = {
                input: {
                    currency: input.currency,
                    description: input.description,
                    ean: input.ean,
                    memorandum: input.memorandum,
                    name: input.name,
                    trademarkID: input.trademarkID,
                    type: input.type,
                    unit: input.unit,
                    unitPrice: this.decimal(input.unitPrice.net),
                    vatRate: this.decimal(input.vatRate)
                }
            }
            const response = await this.client.request(CreateDeliverableDocument, variables)
            return response.createDeliverable.id
        } catch (error) {
            this.handleError(error)
        }
    }

    public async update(input: DeliverableModel) {
        try {
            const variables: UpdateDeliverableMutationVariables = {
                input: {
                    currency: input.currency,
                    description: input.description,
                    ean: input.ean,
                    id: input.id,
                    memorandum: input.memorandum,
                    name: input.name,
                    type: input.type,
                    unit: input.unit,
                    unitPrice: this.decimal(input.unitPrice.net),
                    vatRate: this.decimal(input.vatRate)
                }
            }
            await this.client.request(UpdateDeliverableDocument, variables)
        } catch (error) {
            this.handleError(error)
        }
    }

    public async remove(deliverableID: string) {
        try {
            const variables: RemoveDeliverableMutationVariables = {
                deliverableID: deliverableID
            }
            await this.client.request(RemoveDeliverableDocument, variables)
        } catch (error) {
            this.handleError(error)
        }
    }
}
